import React from "react";
import "./explore.scss";

const ExploreWayBox = () => {
  return (
    <div className="explore-way-box">
      <h2>Explore ways to make your web & app great</h2>
      <p>See how and why to integrate AstrologyAPI into your business.</p>
      <button className="button">See use Cases</button>
    </div>
  );
};

export default ExploreWayBox;
